import React from 'react';
import { Box } from '@material-ui/core';
import carfixLogo from '../../assets/images/carfix_newlogo.svg';
import { useHistory } from 'react-router-dom';

interface LogoProps {
  height?: number | string;
}

const Logo: React.FC<LogoProps> = ({ height = 72 }) => {
  const history = useHistory();

  return (
    <Box
      display="flex"
      justifyContent="center"
      onClick={() => history.push('/auth/login')}
      style={{ cursor: 'pointer' }}
    >
      <img src={carfixLogo} alt="Carfix Connect" style={{ height }} />
    </Box>
  );
};

export default Logo;
